<template>
  <div id="app">
    <SidebarComponent style="z-index: 2" v-if="!$route.meta.hideNavbar" />
    <div class="stacked-components" :style="computedStyles">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>

import { computed } from "vue";
import SidebarComponent from '@/components/SidebarComponents/SidebarComponent'
import { sidebarHeight, marginLeft } from "@/components/SidebarComponents/state";

export default {
  name: 'App',
  components: { SidebarComponent},
  title: 'App',


  setup() {

    // Reactive styles for dynamic layout adjustments
    const dynamicStyles = computed(() => ({
      marginLeft: marginLeft.value,
      marginTop: sidebarHeight.value,
    }));

    return { dynamicStyles }
  },


  computed: {
    computedStyles() {
      return this.$route.meta.hideNavbar ? null : this.dynamicStyles;
    }
  },
};

</script>


<style >


.stacked-components {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

</style>